import React from "react"
import Title from "./Title"
import styled from "styled-components"
import ReviewsCard from "./ReviewsCard"

const Reviews = () => {
  return (
    <Container>
      <div className="section section-center">
        <Title
          title="Testimonios"
          subtitle="La Rent a Car mejor evaluada de la zona"
        />
        <ReviewsCard />
      </div>
    </Container>
  )
}

export default Reviews

const Container = styled.section`
  background: var(--white);
`
